import { useSelector } from '../../../core/redux/store';
import selectAllToasts from '../../../core/toast/selector';
import Toast from './Toast';

const Toaster = () => {
  const toasts = useSelector(selectAllToasts);

  if (!toasts.length) return null;

  return (
    <div className="absolute w-full">
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} />
      ))}
    </div>
  );
};

export default Toaster;
